module.exports = __webpack_public_path__ + "r-v3/img/virtual_background_inside_02.7a584896.png";